/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import ErrorIcon from '@mui/icons-material/esm/Error';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
// import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
// import Collapse from '@mui/material/Collapse';
// import IconButton from '@mui/material/IconButton';
// import ExpandMoreIcon from '@mui/icons-material/esm/ExpandMore';
import LinearProgress from '@mui/material/LinearProgress';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { withStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { accessManager } from '../../helper/AccessManager';
import ConfigManager from '../../helper/ConfigManager';
import gatewayClient from '../../helper/GatewayClient';
import theme from '../../theme';

const CONFIG = ConfigManager.config.gatewayClientConfig;

const styles = {
	actions: {
		display: 'flex'
	},
	expand: {
		transform: 'rotate(0deg)',
		marginLeft: 'auto',
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.shortest
		})
	},
	expandOpen: {
		transform: 'rotate(180deg)'
	}
};
// const AUTH_URL = `${CONFIG.restEndpointURL}/auth/provider/`;
// const ALL_PROVIDERS = [
// 	{
// 		id: 'ldap',
// 		text: 'LDAP',
// 		type: 'form',
// 	},
// 	{
// 		id: 'github',
// 		text: 'Github',
// 	},
// 	{
// 		id: 'google',
// 		text: 'google',
// 	},
// 	{
// 		id: 'openid',
// 		text: 'openid',
// 	},
// 	{
// 		id: 'oauth2',
// 		text: 'oauth2',
// 	},
// 	{
// 		id: 'hydra',
// 		text: 'Hydra',
// 	},
// ];

const doLogin = async (request) => {
	try {
		await gatewayClient.connect(CONFIG);
		const resp = await gatewayClient.authenticate(request);
		return resp.response || resp;
	} catch (error) {
		return { error: error.error };
	}
};

const login = (credentials, redirect) =>
	doLogin(credentials).then((response) => {
		if (!response.error && response.token) {
			accessManager.loginUI(response.token, redirect);
			return true;
		}
		return response;
	});

function LoginPage() {
	const providerId = 'internal';
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const [error, setError] = useState(false);

	const navigate = useNavigate();

	const handleLogin = async (e, pId, redirect) => {
		if (e.preventDefault) {
			e.preventDefault();
		}
		if (username && password) {
			try {
				const resp = await login(
					{
						username,
						password,
						providerId: pId || providerId
					},
					redirect
				);
				setError(resp.error);
			} catch (err) {
				setError(err);
			}
		} else {
			setError('INVALID');
		}
	};

	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		const token = params.get('token');
		const existingToken = accessManager.authToken;
		const redirectParam = params.get('redirect');
		const redirect = redirectParam ? decodeURIComponent(redirectParam) : '/home';
		if (existingToken) {
			navigate(redirect);
		} else if (token) {
			localStorage.removeItem('jwtToken');
			localStorage.removeItem('user');
			accessManager.loginWithToken({ token });
			navigate(redirect);
		}
	}, []);

	// const handleExpandClick = () => {
	// 	this.setState((state) => ({ expanded: !state.expanded }));
	// };

	// const handleProviderChange = (event) => {
	// 	const providerId = event.target.value;
	// 	const provider = this.state.providers.find((p) => p.id === providerId);
	// 	if (provider && !provider.type) {
	// 		window.location.href = `${AUTH_URL}${providerId}`;
	// 	} else {
	// 		this.setState({ providerId });
	// 	}
	// 	if (provider.type === 'form') {
	// 		this.forceUpdate();
	// 		this.handleLogin(event, providerId);
	// 	}
	// };

	const params = new URLSearchParams(window.location.search);
	const token = params.get('token');
	const redirect = params.get('redirect');
	// eslint-disable-next-line react/prop-types
	const errorMessage = error || params.get('error');
	return (
		<StyledEngineProvider injectFirst>
			<ThemeProvider theme={theme}>
				<img
					alt=""
					src="images/loginstreams.svg"
					style={{
						position: 'absolute',
						left: '50px',
						top: '50px'
					}}
				/>
				<img
					alt=""
					src="images/loginlogo.svg"
					style={{
						position: 'absolute',
						left: '50px',
						bottom: '50px'
					}}
				/>
				<div
					style={{
						width: '100vw',
						height: '100vh',
						backgroundColor: '#F0F0F0'
						// backgroundSize: '100% 100%',
						// backgroundImage: 'url(images/loginlogo.jpg)',
					}}
				>
					{token ? (
						<LinearProgress thickness={30} />
					) : (
						<div
							style={{
								width: '100vw',
								height: '100vh'
								// backgroundSize: 'cover',
							}}
						>
							<Card
								style={{
									width: '400px',
									top: '30%',
									left: '50%',
									marginLeft: '-200px',
									position: 'relative'
								}}
							>
								<CardContent>
									<h2>
										<FormattedMessage id="Login.title" defaultMessage="Login" />
									</h2>
									{!errorMessage ? null : (
										<div
											style={{
												color: '#D8000C',
												backgroundColor: '#FFD2D2',
												margin: '4px',
												border: 'dotter red 2px'
											}}
										>
											<ErrorIcon />
											<span
												style={{
													margin: '0px 3px',
													top: '-5px',
													position: 'relative',
													fontWeight: 'bolder'
												}}
											>
												{errorMessage}
											</span>
										</div>
									)}

									<form name="form">
										<TextField
											fullWidth
											variant="outlined"
											margin="normal"
											size="small"
											hinttext={<FormattedMessage id="Login.userHint" defaultMessage="Login" />}
											required
											error={errorMessage}
											label={<FormattedMessage id="Login.userName" defaultMessage="Username" />}
											value={username}
											onChange={(event) => setUsername(event.target.value)}
										/>
										<br />
										<TextField
											fullWidth
											variant="outlined"
											margin="normal"
											size="small"
											type="password"
											hinttext="Enter your Password"
											required
											error={errorMessage}
											label={<FormattedMessage id="Login.password" defaultMessage="Password" />}
											value={password}
											onChange={(event) => setPassword(event.target.value)}
										/>
										<Divider variant="inset" component="br" />
										<Button
											fullWidth
											variant="outlined"
											type="submit"
											size="large"
											onClick={(event) => handleLogin(event, undefined, redirect)}
										>
											<FormattedMessage id="Login" defaultMessage="Login" />
										</Button>
									</form>
								</CardContent>
								{/* <CardActions className={classes.actions} disableSpacing>
                                        <IconButton
                                            className={classnames(classes.expand, {
                                                [classes.expandOpen]: this.state.expanded,
                                            })}
                                            onClick={this.handleExpandClick}
                                            size="large">
                                            <ExpandMoreIcon />
                                        </IconButton>
                                    </CardActions>
                                    <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
                                        <CardContent>
                                            <TextField
                                                fullWidth
                                                variant="outlined"
                                                margin="normal"
                                                size="small"
                                                type="text"
                                                hinttext="Enter the Socket API URL"
                                                required
                                                label={
                                                    <FormattedMessage id="Label.SocketAPI" defaultMessage="Socket API" />
                                                }
                                                value={this.state.socketEndpointURL}
                                                onChange={(event) => {
                                                    CONFIG.socketEndpointURL = event.target.value;
                                                    this.setState({ socketEndpointURL: event.target.value });
                                                    localStorage.setItem('socketEndpointURL', event.target.value);
                                                }}
                                            />
                                            <br />
                                            <TextField
                                                fullWidth
                                                variant="outlined"
                                                margin="normal"
                                                size="small"
                                                type="text"
                                                hinttext="Enter the REST API URL"
                                                required
                                                label={<FormattedMessage id="Label.RESTAPI" defaultMessage="REST API" />}
                                                value={this.state.restEndpointURL}
                                                onChange={(event) => {
                                                    CONFIG.restEndpointURL = event.target.value;
                                                    this.setState({ restEndpointURL: event.target.value });
                                                    localStorage.setItem('restEndpointURL', event.target.value);
                                                }}
                                            />
                                        </CardContent>
                                    </Collapse> */}
							</Card>
						</div>
					)}
				</div>
			</ThemeProvider>
		</StyledEngineProvider>
	);
}

export default withStyles(styles)(LoginPage);
